import { ITransaction } from "../interface/ITransactionHistory";
import { IPageableResponse } from "@common/Pagination/interface/IPageableResponse";

interface ITransactionResponse {
    amount: number;
    dateTime: string;
    reference: string;
    totalBalance: number;
    transactionType: string;
    paymentCorrelationTransactionUuid: string;
}

export interface IPageableTransactionsHistoryResponse {
    transactionsPage: IPageableResponse<ITransactionResponse>;
}

export const getResponseToState = (
    response: IPageableTransactionsHistoryResponse
): IPageableResponse<ITransaction> => ({
    content: response.transactionsPage.content.map((transaction) => ({
        amount: transaction.amount,
        dateTime: transaction.dateTime,
        reference: transaction.reference,
        totalBalance: transaction.totalBalance,
        transactionType: transaction.transactionType,
        paymentCorrelationTransactionUuid: transaction.paymentCorrelationTransactionUuid,
    })),
    totalPages: response.transactionsPage.totalPages,
});
